module.exports = __webpack_public_path__ + "assets/img/c3.52787e3e.jpg";